import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class WacofCriteria extends Model.CriteriaBase {
    static typeName = "WacofCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.add(DateUtils.today(), { months: -1 }));

    @Attributes.Nullable()
    public entityId: number | null = null;

    @Attributes.Nullable()
    public investorReferralTypeId: number | null = null;

    @Attributes.Nullable()
    public portfolioTypeId: number | null = null;

    @Attributes.NullableBoolean()
    public isFlexiDiv: boolean | null = null;

    @Attributes.NullableBoolean()
    public isCommission: boolean | null = null;

    public useEndDateCapital: boolean = false;

    public investorIds: number[] = [];

    // Client only properties / methods

    @Attributes.NoTracking()
    public investorNames: Model.ISelectedItem[] = [];

    protected addBusinessRules(rules: Validation.Rules<WacofCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Weighted Average Cost of Funds Criteria";
    }
}